import { useTimeControlStore, useTimeStore } from "@graphic/stores";
import { useGeoLocation } from "./use-geo-location";

import { convertGeoToEci } from "@graphic/utils/coord";

export const useStartPosition = () => {
  const { location } = useGeoLocation();
  const { latitude, longitude } = location;
  const defaultTime = useTimeControlStore(state => state.defaultTime);
  const startPosition = convertGeoToEci(latitude, longitude, defaultTime);

  return startPosition;
};
